"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _actions = require("./actions");

var _UserAppAttribute = _interopRequireDefault(require("./UserAppAttribute"));

var _fluxActions = require("flux-actions");

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchAttributesActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_UserAppAttribute.default, action.payload.data.attributes, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchSettingsAttributesActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_UserAppAttribute.default, action.payload.data.attributes, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateAttributeActionTypes.SUCCESS, function (state, action) {
  var attribute = action.payload.data;
  return state.set(attribute.id, new _UserAppAttribute.default(attribute));
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteAttributeActionTypes.SUCCESS, function (state) {
  // TODO: remove the attribute
  return state;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;